<template>
  <BaseCard :title="'clairgreen.com'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Solo Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">October 2024 - Present</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          When I think about why I chose Computer Science, my own website immediately comes to mind.
          It is my purest form of bringing my ideas to life through code, a phrase that I use very
          often to explain my experience with the subject. Out of pure passion, I have iterated through
          version after version of clairgreen.com, adding new pages, more features and animations, and in some cases,
          an entirely new style. this project embodies my love for creation, especially having the ability to pull
          ideas directly from my imagination and make them a reality.
        </span>
        <span class="block">
          This website heavily builds on my experience at <a class="link-in-text" href="/skills-experience">BoxCast</a>,
          primarily by building entirely from scratch in Vue.js, focusing on reactive and easy-to-use designs,
          and promoting clean code throughout the process. No one but me can see it, yet I'm truly proud of the
          structure bringing this passion project together. With 10 reactive pages, 5 animations designed by me from scratch,
          and a style system that reflects both my personality and willingness to step beyond norms, this website has become
          my favorite project yet. All without a single line of AI-generated code.
        </span>
      </p>
      <span class="flex flex-col place-items-center overflow-hidden">
        <img class="w-[60%] h-auto rounded-lg cursor-pointer" :src="WebsiteGif" @click="openImageMenu(WebsiteGif, 'clairgreen.com Demo', $event.currentTarget)">
      </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import WebsiteGif from '@/assets/Projects/WebsitePhotos/WebsiteGif.gif';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>